import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * User location interface
 */
export interface UserLocation {
  latitude: number;
  longitude: number;
  address?: string;
  city?: string;
  state?: string;
}

interface UserLocationState {
  location: UserLocation | null;
}

const initialState: UserLocationState = {
  location: null,
};

/**
 * User location slice managing user's geographical location
 */
const userLocationSlice = createSlice({
  name: "userLocation",
  initialState,
  reducers: {
    setUserLocation: (state, action: PayloadAction<UserLocation | null>) => {
      state.location = action.payload;
    },
    updateUserLocation: (state, action: PayloadAction<UserLocation>) => {
      state.location = action.payload;
    },
    clearUserLocation: (state) => {
      state.location = null;
    },
  },
});

export const { setUserLocation, updateUserLocation, clearUserLocation } =
  userLocationSlice.actions;

// Selectors
export const selectUserLocation = (state: {
  userLocation: UserLocationState;
}) => state.userLocation.location;

export default userLocationSlice.reducer;
